import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box } from "@material-ui/core";
import useStyles, {  } from "../Styles";
import { getWindowSize } from "../utils";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";
import ReactDOMServer from 'react-dom/server';
import { DONUT_CHART_CONTENTS } from '../constants'
// import userActions from "../actions";

const CitiesDonut = ({ city_metrics }) => {
  const [windowSize, setWindowSize] = useState(getWindowSize());
  const classes = useStyles();
  const { isMobile } = useGetViewPortDimensions();
  // const { resetSelectedCity } = userActions();
  const [options, setOptions] = React.useState(null);

  Highcharts.setOptions({
    chart: {
      style: {
        fontFamily: "Arial",
      },
    },
    responsive: {
      rules: [{
          condition: {
              maxWidth: 380,
              maxHeight: 380
          },
      }]
  }
  });

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize(getWindowSize());
    };
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  const displayText = Object.keys(city_metrics).length !== 0 ? (
    ReactDOMServer.renderToStaticMarkup(
      <>
        <p className={`${classes.chartContent} ${isMobile ? classes.mobileContent : classes.browserContent}`}>
          {DONUT_CHART_CONTENTS['Chart_Content']}
        </p>
        <br />
        <p className={classes.chartContentBoldText}>
          {city_metrics?.total_deliveries?.toLocaleString("en-US")} ac-ft
        </p>
      </>
    )
  ) : DONUT_CHART_CONTENTS['No_Data']

  useEffect(() => {
    const optionsTemp = {
      chart: {
        type: "pie",
        plotBackgroundColor: "transparent",
        backgroundColor: "transparent",
        // height:
        //   window.innerHeight -
        //   toolbarHeight -
        //   filterContainerHeight -
        //   chartTitleHeight -
        //   145,
        height: 780,
        width: isMobile ? 380 : 640,
        // height: '60%',
        // ...(isMobile && { width: 380 }),
      },
      title: {
        text: displayText,
        align: "center",
        verticalAlign: "middle",
        style: {
          color: "#000",
          lineHeight: "25px",
        },
        y: isMobile ? -70 : -23,
      },
      series: [],
      credits: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: false,
          },
          states: {
            hover: {
              enabled: false,
            },
            inactive: {
              opacity: 1,
            },
          },
          borderWidth: 0,
          showInLegend: true,
        },
        series: {
          point: {
            events: {
              legendItemClick: function () {
                return false; // <== returning false will cancel the default action
              },
            },
          },
        },
      },
      tooltip: {
        followPointer: false,
        padding: 8,
        backgroundColor: "#FFF",
        borderRadius: 8,
        outside:true,
        useHTML: true,
        style: {
          color: "#000",
          fontFamily: "'Arial', sans-serif",
          lineHeight: "1.5em",
        },
        formatter() {
          const name = this.point.name;
          const value = this.point.y;
          let tooltip = `Delivery: <b>${name}</b></br>`;
          tooltip += `Water use amount: <b>${value.toLocaleString(
            "en-US"
          )} ac-ft</b><br>`;
          tooltip += `<br>`;
          tooltip += `Water Source Breakdown:<br>`;
          if (name === "Tap") {
            tooltip += `Colorado River: <strong>${Math.round(
              city_metrics.tap_colorado * 100
            )}%</strong><br>`;
            tooltip += `Salt & Verde: <strong>${Math.round(
              city_metrics.tap_salt_and_verde * 100
            )}%</strong><br>`;
            tooltip += `Groundwater: <strong>${Math.round(
              city_metrics.tap_groundwater * 100
            )}%</strong><br>`;
            tooltip += `Agua Fria: <strong>${Math.round(
              city_metrics.tap_agua_fria * 100
            )}%</strong><br>`;
          }

          if (name === "Turf Facilities") {
            tooltip += `Colorado River: <strong>${Math.round(
              city_metrics.turf_colorado * 100
            )}%</strong><br>`;
            tooltip += `Salt & Verde: <strong>${Math.round(
              city_metrics.turf_salt_and_verde * 100
            )}%</strong><br>`;
            tooltip += `Groundwater: <strong>${Math.round(
              city_metrics.turf_groundwater * 100
            )}%</strong><br>`;
            tooltip += `Reclaimed Water: <strong>${Math.round(
              city_metrics.turf_reclaimed_water * 100
            )}%</strong><br>`;
            tooltip += `Other River Water: <strong>${Math.round(
              city_metrics.turf_other_river_water * 100
            )}%</strong><br>`;
          }

          if (name === "Recharge") {
            tooltip += `Colorado River: <strong>${Math.round(
              city_metrics.aquifer_recharge_colorado * 100
            )}%</strong><br>`;
            tooltip += `Salt & Verde: <strong>${Math.round(
              city_metrics.aquifer_recharge_salt_and_verde * 100
            )}%</strong><br>`;
            tooltip += `Reclaimed Water: <strong>${Math.round(
              city_metrics.aquifer_recharge_reclaimed_water * 100
            )}%</strong><br>`;
          }

          if (name === "Agriculture (GSF)") {
            tooltip += `Colorado River: <strong>${Math.round(
              city_metrics.agriculture_colorado * 100
            )}%</strong><br>`;
            tooltip += `Salt & Verde: <strong>${Math.round(
              city_metrics.agriculture_salt_and_verde * 100
            )}%</strong><br>`;
            tooltip += `Reclaimed Water: <strong>${Math.round(
              city_metrics.agriculture_reclaimed_water * 100
            )}%</strong><br>`;
          }

          if (name === "Exchange") {
            tooltip += `Colorado River: <strong>${Math.round(
              city_metrics.exchange_colorado * 100
            )}%</strong><br>`;
            tooltip += `Reclaimed Water: <strong>${Math.round(
              city_metrics.exchange_reclaimed_water * 100
            )}%</strong><br>`;
          }

          return tooltip;
        },
      },
      legend: {
        itemStyle: {
          color: "#333333",
          fontSize: "17px",
          fontWeight: "normal",
          fontFamily: "Arial",
        },
        verticalAlign : "bottom",
        align: "center",
        backgroundColor: "#FFFFFF",
        borderColor: "#E0E0E0",
        borderWidth: 1,
        borderRadius: 15,
        //   width: "25%",
        padding: 10,
        itemMarginTop: 5,
        itemMarginBottom: 5,
        shadow: {
          offsetX: -1,
          offsetY: 3,
          color: "#00000029",
          width: 4,
        },
        reversed: true,
      },
    };

    let series = [];
    if (Object.keys(city_metrics).length) {
      series = [
        {
          name: "Cities Water Usage",
          innerSize: "70%",
          data: [
            {
              name: "Turf Facilities",
              y: Math.round(city_metrics.turf_total),
              color: "#43B99E",
            },
            {
              name: "Exchange",
              y: Math.round(city_metrics.exchange_total),
              color: "#96D9E4",
            },
            {
              name: "Recharge",
              y: Math.round(city_metrics.aquifer_recharge_total),
              color: "#FFB607",
            },
            {
              name: "Agriculture (GSF)",
              y: Math.round(city_metrics.agriculture_total),
              color: "#DE3E40",
            },
            {
              name: "Tap",
              y: Math.round(city_metrics?.tap_total),
              color: "#2352D0",
            },
          ],
        },
      ];
    }

    optionsTemp.series = series;
    setOptions(optionsTemp);
  }, [city_metrics, windowSize, isMobile]);

  //gets windowSize to set width of barchart

  return (
    <Box className={classes.chartContainer}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Box>
  );
};
export default CitiesDonut;
